import gql from 'graphql-tag';

export const integrationBoxFragment = gql`
  fragment integrationBoxFragment on IntegrationBox {
    dokkioClass
    id
    accountID
    syncFolderRemoteID
    syncFolderPath
  }
`;
export default integrationBoxFragment;
